export default {
  container: {
    display: 'flex',
    borderRadius: 8,
    alignItems: 'center',
    paddingLeft: 24,
    paddingRight: 24,
  },
};
